import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Component.css";
import Logo from "../Assets/RPM logo_white.png";

const Footer = () => {
  return (
    <footer
      className="footer-container text-light py-5"
      style={{ maxWidth: "100%" }}
    >
      <Container>
        <Row className="footer-row" style={{ alignItems: "flex-start" }}>
          <Col xs={12} md={4} lg={4} className="mb-4 footer-col">
            <h3>
              <img
                src={Logo}
                alt="RPM Automotif Logo"
                style={{ width: "160px", height: "auto" }}
              />
            </h3>
            <p>PT RAJA PERKASA MOTOR</p>
          </Col>
          <Col xs={12} md={4} lg={4} className="mb-4 footer-col">
            <h3>
              {localStorage.getItem("bahasa") === "ing"
                ? "Social media"
                : "Sosial media"}
            </h3>
            <ul className="list-unstyled">
              <li>
                <Button
                  variant="none"
                  href="https://www.tiktok.com/@rpmotomotif_?_t=8L9203k068c&_r=1"
                  className="link-footer"
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontSize: "25px" }}
                >
                  <i className="bi bi-tiktok"></i>
                </Button>
                <Button
                  variant="none"
                  href="https://www.instagram.com/rpmotomotif?igsh=aDFpYTNtb2huaDFj&utm_source=qr"
                  className="link-footer"
                  style={{ fontSize: "25px" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-instagram"></i>
                </Button>
              </li>
              <li>
                <Button
                  variant="none"
                  href="https://wa.me/6281932536022"
                  className="link-footer"
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontSize: "25px" }}
                >
                  <i className="bi bi-whatsapp "></i>
                </Button>
                <Button
                  variant="none"
                  href="mailto:rajaperkasamotor@gmail.com?subject=Hello&body=I'm interested in your services. Please provide more information."
                  className="link-footer"
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontSize: "25px" }}
                >
                  <i className="bi bi-google"></i>
                </Button>
              </li>
            </ul>
          </Col>
          <Col xs={12} md={4} lg={4} className="mb-4 footer-col" style={{ justifyContent: "flex-start" }}>
            <h3>
              {localStorage.getItem("bahasa") === "ing" ? "Location" : "Lokasi"}
            </h3>
            <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
              <li style={{ textAlign: "start", maxWidth: "200px" }}>
                Jl. H. Samali No.02, Rw.01, Pejaten Barat, Pasar Minggu,
                Jakarta, Indonesia 12510 <br />
                <br />
                <iframe
                  title="map-RPM Automotif"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.9811035519706!2d106.83851817475104!3d-6.266215193722444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1c053c5848f%3A0x197a737a40256a1b!2sWecarcare!5e0!3m2!1sid!2sid!4v1704332032309!5m2!1sid!2sid"
                  width="250"
                  height="250"
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
      <div className="bg-red text-center py-3">
        <p>&copy; 2019 PT RAJA PERKASA MOTOR. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
